module.exports = __webpack_public_path__ + "img/Delete.997d6c36.png";